/* RESPONSIBLE TEAM: team-automation-foundations */
import StepSerializer from '../step';

export default class ReplyButtonsSerializer extends StepSerializer {
  serialize(snapshot: any, options: any) {
    let json = super.serialize(snapshot, options);

    // Explicitly include conversationAttributeDescriptorId and quickReplyMode for phone
    // CDA write and language selection features. The parent serializer may not pick up
    // newly-added @attr fields without a full rebuild, so we ensure they are always present.
    let descriptorId = snapshot.attr('conversationAttributeDescriptorId');
    if (descriptorId !== undefined && descriptorId !== null) {
      json.conversation_attribute_descriptor_id = descriptorId;
    }

    let quickReplyMode = snapshot.attr('quickReplyMode');
    if (quickReplyMode !== undefined && quickReplyMode !== null) {
      json.quick_reply_mode = quickReplyMode;
    }

    return json;
  }
}
